import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { useStore } from '../../contexts/StoreContext';
import { leadStatusSteps } from '../../data/options';
import { Lead } from '../../types/lead';
import { formatDateTime } from '../../utils/format';
import { normalizePhone } from '../../utils/validation';
export function LeadProgress({
  lead
}: {
  lead: Lead;
}) {
  const current = leadStatusSteps.findIndex(s => s.id === lead.status);
  return <ol className="space-y-0" data-id="element-505" data-mp="wl7rhjfupwjz">
      {leadStatusSteps.map((s, i) => {
      const done = i <= current;
      const entry = [...lead.timeline].reverse().find(t => t.status === s.id);
      return <li key={s.id} className="relative flex gap-4 pb-6 last:pb-0" data-id="element-506" data-mp="huh02ci68zhe" data-mpi={i}>
            {i < leadStatusSteps.length - 1 && <span className={`absolute left-[11px] top-6 h-full w-px ${i < current ? 'bg-neon' : 'bg-line'}`} aria-hidden data-id="element-507" data-mp="1f9l3u6llm0o6" />}
            <span className={`relative z-10 grid h-6 w-6 shrink-0 place-items-center rounded-full border text-[10px] ${done ? 'border-neon bg-neon text-white' : 'border-line bg-surface text-mist'}`} data-id="element-508" data-mp="1aiwfh057tjt9">
              {done ? <CheckIcon className="h-3.5 w-3.5" data-id="element-509" data-mp="78chfb1p8q2p" /> : i + 1}
            </span>
            <div className="-mt-0.5" data-id="element-510" data-mp="3oqds8b72ycyf">
              <p className={`text-sm font-semibold ${done ? 'text-white' : 'text-mist'}`} data-id="element-511" data-mp="3opcd9vmy16bf">
                {s.label}
                {i === current && <span className="sr-only" data-id="element-512" data-mp="3fp78lt94wm0y"> (estado actual)</span>}
              </p>
              <p className="text-xs text-mist" data-id="element-513" data-mp="3fra42st237d2">{entry ? `${formatDateTime(entry.at)} · ${entry.note}` : s.description}</p>
            </div>
          </li>;
    })}
    </ol>;
}
export function StatusTracker({
  initialCode = ''
}: {
  initialCode?: string;
}) {
  const {
    leads
  } = useStore();
  const [code, setCode] = useState(initialCode);
  const [phone, setPhone] = useState('');
  const [result, setResult] = useState<Lead | null | 'not-found'>(null);
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const found = leads.find(l => l.code.toUpperCase() === code.trim().toUpperCase() && (!l.phone || normalizePhone(phone).endsWith(l.phone.slice(-4))) && normalizePhone(phone).length >= 4);
    setResult(found ?? 'not-found');
  };
  return <div data-id="element-514" data-mp="xlh4r4bklcxc">
      <form onSubmit={onSubmit} className="grid gap-3 sm:grid-cols-[1fr_1fr_auto]" data-id="element-515" data-mp="xl7pobs2cq6f">
        <div data-id="element-516" data-mp="sm4m6vrqes0k">
          <label htmlFor="trk-code" className="label" data-id="element-517" data-mp="smo3qbdgzee2">Número de seguimiento</label>
          <input id="trk-code" className="input font-mono uppercase" value={code} onChange={e => setCode(e.target.value)} placeholder="VC-XXXXXX" maxLength={12} data-id="element-518" data-mp="1q7aexyz73tu5" />
        </div>
        <div data-id="element-519" data-mp="1ggxqhvo9fgiq">
          <label htmlFor="trk-phone" className="label" data-id="element-520" data-mp="1ggfpymukeg50">Teléfono registrado</label>
          <input id="trk-phone" className="input" inputMode="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Para validar tu identidad" maxLength={20} data-id="element-521" data-mp="1bie6i0t88et0" />
        </div>
        <button type="submit" className="btn btn-ghost self-end" data-id="element-522" data-mp="2471jza7qhzw0">Consultar</button>
      </form>
      {result === 'not-found' && <p className="mt-4 text-sm text-danger" role="alert" data-id="element-523" data-mp="2cik42wmfmjf8">No encontramos una consulta con esos datos. Revisá el número y el teléfono.</p>}
      {result && result !== 'not-found' && <div className="mt-6 rounded-2xl border border-line bg-panel p-5" data-id="element-524" data-mp="2lfugilazkelq">
          <p className="text-xs text-mist" data-id="element-525" data-mp="2qh1l6bhu0xo6">Consulta {result.code} · {result.vehicleLabel ?? 'Sin unidad específica'}</p>
          <p className="mb-5 mt-1 font-semibold" data-id="element-526" data-mp="2vf3671ytj72a">Hola {result.name.split(' ')[0]}, este es el estado de tu consulta:</p>
          <LeadProgress lead={result} data-id="element-527" data-mp="2zeke021pwgam" />
          {result.assignedTo && <p className="mt-5 text-sm text-mist" data-id="element-528" data-mp="3486qnu7vsk6f">Asesor asignado: <span className="text-white" data-id="element-529" data-mp="396glg3pp1iri">{result.assignedTo}</span></p>}
        </div>}
    </div>;
}